<template>
  <div class="phone-message auto boxsizing">
    <div v-if="data.length">
      <div class="messagefor auto" v-for="(item, index) in data" :key="index">
        <div class="messagebox auto" v-if="item.type !== 'news' && item.type !== 'article' && item.type && item.type !== 'mpnews' && item.type !== 'video' && item.type !== 'view' && item.type !== 'miniprogram'">
          <div class="pichead auto">
            <img :src="user.head_img" class="bg">
          </div>
          <div class="talkimg" v-if="item.type === 'image'">
            <img :src="item.url" alt="">
          </div>
          <div class="talkright" v-else>
            <div class="talkrightbox auto" v-if="item.type === 'local_text'">
              <div class="textbox auto" v-html="item.content.replace(/\n/g, '<br>').replace(/  /g, '&nbsp;&nbsp;')"></div>
            </div>
            <div class="talkrightbox auto" v-if="item.type === 'text'">
              <div class="textbox auto" v-html="item.text.replace(/\n/g, '<br>').replace(/  /g, '&nbsp;&nbsp;')"></div>
            </div>
            <div class="talkrightbox minirightbox auto" v-else-if="item.type === 'local_miniprogrampage'">
              <dl>
                <dt>{{item.content.title}}</dt>
                <dd>
                  <img src="../../../assets/opacity.png" alt="" class="bg">
                  <img :src="item.content.thumb_media_url" class="picimg" alt="">
                </dd>
              </dl>
              <p>小程序</p>
            </div>
            <div class="talkrightbox minirightbox auto" v-else-if="item.type === 'miniprogrampage'">
              <dl>
                <dt>{{item.title}}</dt>
                <dd>
                  <img src="../../../assets/opacity.png" alt="" class="bg">
                  <img :src="item.thumb_media_url" class="picimg" alt="">
                </dd>
              </dl>
              <p>小程序</p>
            </div>
            <div class="talkrightbox minirightbox auto musicrightbox" v-else-if="item.type === 'music'">
              <dl>
                <dt style="float:left;line-height:20px;">
                  {{item.content.title}}<br>
                  <span style="font-size:12px;">{{item.content.description}}</span>
                </dt>
                <dd style="float:right;width:30px;">
                  <img style="width:100%;" src="data:image/png;base64,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">
                </dd>
              </dl>
              <a :href="item.content.musicurl" target="_blank"><span>预览</span></a>
            </div>
            <div class="arrow"><em></em></div>
            <div class="clear auto"></div>
          </div>
        </div>
        <div class="messagebox auto" v-else-if="item.type === 'view' && item.url">
          <div class="talkright boxsizing" style="display:block;width:100%;margin:0;">
            <div class="talkrightbox auto">
              <div class="textbox auto">
                这里是跳转链接，链接是<a :href="item.url" target="_blank">{{item.url}}</a>
              </div>
            </div>
          </div>
        </div>
        <div class="messagebox auto" v-else>
          <div class="newsbox auto" v-if="item.type === 'mpnews' || !item.type">
            <div class="listbox-top">
              <dl class="noposter" v-if="!!!item[0].cover">
                <dt>{{item[0].title}}</dt>
                <dd>{{item[0].description}}</dd>
              </dl>
              <div class="hasposterBox" v-if="!!item[0].cover">
                <dl class="hasposter">
                  <dt v-if="item.length > 1">{{item[0].title}}</dt>
                  <dd><img :src="item[0].cover" alt=""></dd>
                </dl>
              </div>
              <dl class="onedl" v-if="item.length === 1">
                <dt>{{item[0].title}}</dt>
                <dd>{{item[0].description}}</dd>
              </dl>
              <a :href="item[0].media_url" target="_blank"><span>预览</span></a>
            </div>
            <div class="listbox-item boxsizing" v-if="item.length > 1 && index2 > 0" v-for="(item2, index2) in item" :key="index2">
              <div class="listbox-itembox">
                <dl>
                  <dt>{{item2.title}}</dt>
                  <dd><img :src="item2.cover" v-if="item2.cover" alt=""></dd>
                </dl>
                <a :href="item2.media_url" target="_blank"><span>预览</span></a>
              </div>
            </div>
          </div>
          <div class="newsbox auto" v-else-if="item.type === 'article'">
            <div class="listbox-top">
              <dl class="noposter" v-if="!!!item[0].content.news_item[0].thumb_url">
                <dt>{{item[0].content.news_item[0].title}}</dt>
                <dd>{{item[0].content.news_item[0].digest}}</dd>
              </dl>
              <div class="hasposterBox" v-else>
                <dl class="hasposter">
                  <dt>{{item[0].content.news_item[0].title}}</dt>
                  <dd><img :src="item[0].content.news_item[0].thumb_url" alt=""></dd>
                </dl>
              </div>
              <a :href="item[0].content.news_item[0].url" target="_blank"><span>预览</span></a>
            </div>
            <div class="listbox-item" v-if="item[0].content.news_item.length > 1 && index2 > 0" v-for="(item2, index2) in item[0].content.news_item" :key="index2">
              <div class="listbox-itembox">
                <dl>
                  <dt>{{item2.title}}</dt>
                  <dd><img :src="item2.thumb_url" v-if="item2.thumb_url" alt=""></dd>
                </dl>
                <a :href="item2.url" target="_blank"><span>预览</span></a>
              </div>
            </div>
          </div>
          <div class="newsbox auto" v-else-if="item.type === 'news'">
            <div class="listbox-top">
              <dl class="noposter" v-if="!!!item.content.articles[0].picurl">
                <dt>{{item.content.articles[0].title}}</dt>
                <dd>{{item.content.articles[0].description}}</dd>
              </dl>
              <div class="hasposterBox" v-if="!!item.content.articles[0].picurl">
                <dl class="hasposter">
                  <dt v-if="item.content.articles.length > 1">{{item.content.articles[0].title}}</dt>
                  <dd><img :src="item.content.articles[0].picurl" alt=""></dd>
                </dl>
              </div>
              <dl class="onedl" v-if="item.content.articles.length === 1">
                <dt>{{item.content.articles[0].title}}</dt>
                <dd>{{item.content.articles[0].description}}</dd>
              </dl>
              <a :href="item.content.articles[0].url" target="_blank"><span>预览</span></a>
            </div>
            <div class="listbox-item boxsizing" v-if="item.content.articles.length > 1 && index2 > 0" v-for="(item2, index2) in item.content.articles" :key="index2">
              <div class="listbox-itembox">
                <dl>
                  <dt>{{item2.title}}</dt>
                  <dd><img :src="item2.picurl" v-if="item2.picurl" alt=""></dd>
                </dl>
                <a :href="item2.url" target="_blank"><span>预览</span></a>
              </div>
            </div>
          </div>
          <div class="newsbox auto" v-else-if="item.type === 'video'">
            <div class="listbox-top">
              <div class="hasposterBox">
                <dl class="hasposter">
                  <dd style="position:relative;">
                    <img :src="item.content.thumb_media_url" alt="">
                    <img style="width: 50px;position:absolute;left: 50%;margin-left: -25px; top: 50%;margin-top: -25px;" src="data:image/png;base64,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" alt="">
                  </dd>
                </dl>
              </div>
              <dl class="onedl">
                <dt>{{item.content.title}}</dt>
                <dd>{{item.content.description}}</dd>
              </dl>
              <a :href="item.content.media_url" target="_blank"><span>预览</span></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="messagebox auto" v-if="data.type === 'miniprogram' && data.appid">
        <div class="talkright boxsizing" style="display:block;width:100%;margin:0;">
          <div class="talkrightbox auto">
            <div class="textbox auto">
              这里是跳转小程序，小程序信息是<br>
              url：{{data.url}}<br>
              appid：{{data.appid}}<br>
              pagepath：{{data.pagepath}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: 'MessageShow',
  props: [
    'value',
    'tips' // 是否开启MessageShow组件的素材过期提醒(当与MaterialShow组件一起使用时不需要开启)
  ],
  data () {
    return {
      data: []
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ])
  },
  watch: {
    'value': function (val) {
      var goTips = false
      for (var key in val) {
        if (val[key].invalid) {
          goTips = true
        }
      }
      if (goTips && this.tips) {
        this.tipsOpen()
        this.data = []
      } else {
        this.data = val
      }
    }
  },
  methods: {
    tipsOpen () {
      this.$alert('有素材已失效，请重新编辑再使用', '提示', {
        confirmButtonText: '确定',
        callback: action => {
          // this.$message({
          //   type: 'info',
          //   message: `action: ${ action }`
          // });
        }
      })
    }
  },
  mounted () {
    this.data = this.value || []
  }
}
</script>

<style scoped>
.phone-message {
  padding: 10px 5px;
  width: 86%;
  /*background: #ece;*/
  position: absolute;
  left: 7%;
  top: 13.2%;
  bottom: 12.5%;
  overflow-y: auto;
}
.phone-message::-webkit-scrollbar { /*滚动条整体样式*/
  width: 5px;
  height: 1px;
}
.phone-message::-webkit-scrollbar-thumb { /*滚动条里面小方块*/
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 3px rgba(0,0,0,0.2);
  background: #535353;
}
.phone-message::-webkit-scrollbar-track { /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 3px rgba(0,0,0,0.2);
  border-radius: 5px;
  background: #EDEDED;
}
.messagebox {
  width: 100%;
  padding-bottom: 10px;
}
.pichead {
  display: inline-block;
  width: 12%;
  vertical-align:top;
}
.pichead img {
  width: 100%;
  border-radius: 5px;
}
.talkright {
  display: inline-block;
  margin-left: 5px;
  position: relative;
  width: 70%;
}
.talkrightbox {
  width: auto;
  border: 1px solid #ccc;
  background: #fff;
  border-radius: 5px;
  vertical-align:top;
}
.arrow {
  display:block;
  width:0;
  height:0;
  border-width:5px 5px 5px 0;
  border-style:solid;
  border-color: transparent #ccc transparent;
  position:absolute;
  top: 10px;
  left: -5px;
}
.arrow em {
  display:block;
  width:0;
  height:0;
  border-width:5px 5px 5px 0;
  border-style:solid;
  border-color: transparent #fff transparent;
  position:absolute;
  top: -5px;
  left: 1px;
}
.talkimg {
  display: inline-block;
  vertical-align:top;
  width: 50%;
  margin-left: 5px;
}
.talkimg img, .talkimg video {
  width: 100%;
  border-radius: 5px;
}
.listbox-top {
  /*border-bottom: 1px solid #eee;*/
  /*padding-bottom: 10px;*/
  position: relative;
}
.listbox-top dl dt {
  font-size: 16px;
}
.noposter dd {
  color: #9a9a9a;
  font-size: 12px;
  line-height: 18px;
  height: 36px;
  overflow: hidden;
  padding-top: 10px;
}
.hasposterBox {
  position: relative;
  height: auto;
  overflow: hidden;
}
.hasposter {
  position: relative;
}
.hasposter dt {
  position: absolute;
  left: 0;
  bottom: 0;
  padding: 8px 5%;
  background: rgba(0,0,0,.55);
  color: #fff;
  width: 90%;
}
.hasposter dd {
  max-height: 130px;
  overflow: hidden;
}
.hasposter dd img{
  width: 100%;
  display: block;
}
.listbox-top a {
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  bottom: 0px;
  background: rgba(0,0,0,.5);
  text-align: center;
  display: none;
}
.listbox-top:hover a {
  display: block;
}
.listbox-top a span {
  color: #fff;
  line-height: 20px;
  position: relative;
  top: 45%;
  /*margin-top: -10px;*/
}
.listbox-item {
  width: 100%;
  margin-top: 10px;
  border-bottom: 1px solid #eee;
  padding: 0 10px 10px;
}
.listbox-item dl {
  width: 100%;
  height: auto;
  overflow: hidden;
  position: relative;
}
.listbox-item dl dt {
  position: absolute;
  right: 70px;
  left: 0;
  font-size: 14px;
  line-height: 20px;
  height: 60px;
  overflow: hidden;
}
.listbox-item dl dd {
  width: 60px;
  height: 60px;
  float: right;
  background: #eee;
}
.listbox-item dl dd img{
  width: 100%;
}
.listbox-itembox {
  position: relative;
}
.listbox-itembox a{
  position: absolute;
  left: -10px;
  top: -10px;
  bottom: -10px;
  right: -10px;
  background: rgba(0,0,0,.5);
  text-align: center;
  display: none;
}
.listbox-itembox:hover a {
  display: block;
}
.listbox-itembox a span {
  color: #fff;
  line-height: 20px;
  position: relative;
  top: 30%;
  /*margin-top: -10px;*/
}
.newsbox {
  width: 100%;
  background: #fff;
  border-radius: 5px;
}
.textbox {
  font-size: 12px;
  padding: 5px;
  line-height: 20px;
}
.minirightbox p {
  font-size: 12px;
  color: #999;
  background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAb1BMVEUAAAB4it11h9x2h9x2h9x2htx8j+R8i+B1h9x2h9x3h92Snv91htt2h9x1h9x4h9x1h9x1h9x2idx1h9t2h9t1htt1h9x1h9x1htx2h9x1h912h9x4h913iN17juOOjuN1iNx2h9t4h958i+B1htvejBiPAAAAJHRSTlMALPLcxKcVEOXXUgXtspU498sx69DPu5+Yc2JeRDwbCYuIRiGBtoolAAAA3ElEQVQoz62S1xKDIBBFWYiFYImm2DWF///G7DJEROOb58U79zi4O8iOo8zuCRfV8EdFgbYE49qFQs8ksJInajOA1wWfYvLcGSueU/oUGBtPpti09uNS68KTMcrQ5jce4kmN/HKn9XVPAo702JEdx9hTUrWUqVrI3KwUmM1NhIWMKdwiGvpGMWZOAj1PZuzAxHwhVSplrajoseBnbyDHAwvrtvKKhdqTtFBkL8wO5ijcsS3G1JMNvQ5mdW7fc0x0+ZcnlJlZiflAomdEyFaM7qeK2JahEjy5ZyU7jC/q/Rz/DgqEuAAAAABJRU5ErkJggg==') no-repeat 10px center;
  text-indent: 25px;
  background-size: auto 60%;
  border-top: 1px solid #eee;
  height: 20px;
  line-height: 20px;
}
.minirightbox {
  /*width: 50%;*/
}
.minirightbox dl {
  margin: 10px;
}
.minirightbox dl dd {
  width: 100%;
  position: relative;
  height: auto;
  overflow: hidden;
}
.minirightbox dl dd img.bg{
  width: 100%;
}
.minirightbox dl dd img.picimg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
}
.onedl {
  padding: 10px;
}
.listbox-top dl.onedl dt {
  font-size: 14px;
}
.listbox-top dl.onedl dd {
  font-size: 12px;
}
.musicrightbox {
  position: relative;
}
.musicrightbox a{
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  right: 0px;
  background: rgba(0,0,0,.5);
  text-align: center;
  display: none;
}
.musicrightbox:hover a {
  display: block;
}
.musicrightbox a span {
  color: #fff;
  line-height: 20px;
  position: relative;
  top: 30%;
  /*margin-top: -10px;*/
}
</style>
